'use client';

import Link from 'next/link';
import Image from 'next/image';

import { Button } from '@shared/ui/components';
import ArrowIcon from '@public/icons/arrow-right.svg';
import NoraSplash from '@public/images/nora-splash.svg';
import NoraRound from '@public/images/nora-round.svg';

import styles from './CTA.module.scss';

export default function CTA() {
  return (
    <div id="alumni" className={styles.container}>
      <Image src={NoraSplash} className={styles.splash} alt="Splash" draggable={false} />

      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div className={styles.title}>
            <div className={styles.title_main}>Quantum Alumni</div>
            <div className={styles.title_sub}>EXCITED TO EXPLORE YOUR QUANTUM JOURNEY?</div>
          </div>

          <div className={styles.text}>
            Our Quantum Alumni community brings together graduates from our Quantum Basic,
            Professional, and Academia programs. As ambassadors of quantum excellence, they continue
            to collaborate, share insights, and lead transformative change across sectors. Join a
            growing global network of future thinkers shaping the quantum era.
          </div>

          <Link href="/?alumni-contact=true" className={styles.button}>
            <Button size="l" variant="filled">
              <div>JOIN NOW</div>
              <Image src={ArrowIcon} alt="Arrow" draggable={false} />
            </Button>
          </Link>

          <Image src={NoraRound} className={styles.nora_1} alt="Round" draggable={false} />
        </div>

        <Image src={NoraRound} className={styles.nora_2} alt="Round" draggable={false} />
      </div>
    </div>
  );
}
